<template>
  <router-view />
</template>

<script>

export default {
  name: 'Authorization'
}
</script>

<style scoped lang="scss">
</style>
